module.exports = __webpack_public_path__ + "static/media/21.d5c3af2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/21.jpg
// module id = 711
// module chunks = 0